import { render } from "./MyAnnouncementsCard.vue?vue&type=template&id=2baa5ca3&scoped=true"
import script from "./MyAnnouncementsCard.vue?vue&type=script&lang=js"
export * from "./MyAnnouncementsCard.vue?vue&type=script&lang=js"

import "./MyAnnouncementsCard.vue?vue&type=style&index=0&id=2baa5ca3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baa5ca3"]])

export default __exports__